/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Participation_ConfirmInputs */

const en_remove_participation_confirm = /** @type {(inputs: Remove_Participation_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you really want to remove this application from participation?`)
};

const de_remove_participation_confirm = /** @type {(inputs: Remove_Participation_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie diese Bewerbung wirklich von der Teilnahme entfernen?`)
};

/**
* | output |
* | --- |
* | "Do you really want to remove this application from participation?" |
*
* @param {Remove_Participation_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const remove_participation_confirm = /** @type {((inputs?: Remove_Participation_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Participation_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_remove_participation_confirm(inputs)
	return en_remove_participation_confirm(inputs)
});